import * as React from 'react';

import {Illustration} from 'shells/illustrations/illustration';
import {Body} from 'shells/typography/body';

export function NoLicenseSplashScreen() {
    return (
        <>
            <Body size='xlarge' isBold={true}>
                You don’t have a license to access Nutshell
            </Body>
            <Body size='large'>
                It looks like there have been changes to your account. If you think this is a
                mistake, please contact an administrator so we can get you back on track.
            </Body>
            <Illustration src='no-messages' width={250} />
        </>
    );
}
